// extracted by mini-css-extract-plugin
export default {"caterpillarContainer":"Caterpillar_caterpillarContainer__SbL4z","caterpillar":"Caterpillar_caterpillar__UctAh","butterfly":"Caterpillar_butterfly__C-Soq"};